const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export async function apiGetDashboard( token : string
): Promise<any> {

  const resp = await fetch(`${apiServerUrl}/api/messages/protected`, {
     headers: {
          Authorization: `Bearer ${token}`,
        },
  });

  console.log(resp)
  if (!resp.ok) {
    console.log(resp)
    throw new Error(`bugger`);
  }

  let x = await resp.json()
  console.log(x)
  return x;
}


export async function apiRegisterUser( id: string, name: string, email: string, token : string
): Promise<any> {

  const resp = await fetch(`${apiServerUrl}/v1/register`, {
      method: "POST",
      headers: {
          Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
          "id": id,
          "email": email,
          "name": name
      })
  });

  if (!resp.ok) {
    throw new Error(`bugger`);
  }

  let x = await resp.json()
  return x;
}


export async function freeClassification(text : string, label: string, id : string, token : string
): Promise<any> {

  const resp = await fetch(`${apiServerUrl}/v1/free/classify`, {
      method: "POST",
      headers: {
          Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
          "id": id,
          "text": text,
          "label" : label,
          "token": token
      })
  });

  if (!resp.ok) {
    throw new Error(`bugger`);
  }

  let x = await resp.json()
  return x;
}


export async function apiClassification(text : string, label: number, id : string, token : string
): Promise<any> {


  let resp = await fetch(`${apiServerUrl}/v1/classify`, {
      method: "POST",
      headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
              'Accept': 'application/json',
      },
      body: JSON.stringify({
            text: "Artificial Intelligence (AI) and blockchain technologies are both transformative technologies that have the potential to revolutionize various industries. The integration of AI and blockchain technologies can create new opportunities and solve existing challenges in various domains. Here are some ways AI can help blockchain technologies: Enhancing Security: Blockchain technology is known for its robust security features. However, AI can help to enhance security even further by detecting and preventing fraud, cyber-attacks, and other security threats in real-time. AI can also be used to verify transactions, identify suspicious activity, and monitor network activity to prevent hacking attempts. Improving Efficiency: AI can help to streamline various blockchain processes, reducing the need for human intervention. For example, AI can be used to automate the validation of transactions, and the execution of smart contracts. This can reduce the time and resources required for blockchain operations and improve overall efficiency. Enabling Smart Contracts: Smart contracts are self-executing contracts with the terms of the agreement between buyer and seller being directly written into lines of code. AI can be used to analyze and interpret the terms of these contracts, ensuring they are executed accurately and efficiently. Enhancing Analytics: Blockchain technology generates massive amounts of data. AI can be used to analyze this data, providing insights into user behavior, network activity, and other key metrics. This can help businesses to make more informed decisions and improve their operations. Improving Scalability: One of the challenges of blockchain technology is its limited scalability. AI can help to address this issue by providing predictive analytics, enabling blockchain networks to adjust their capacity based on demand. AI can also be used to optimize the allocation of resources to improve overall scalability. Overall, the integration of AI and blockchain technologies can lead to more secure, efficient, and scalable blockchain solutions, enabling new use cases and unlocking new opportunities across various industries.",
            known: 0
            })
  });


  if (!resp.ok) {
    throw new Error("err");
  }

  return await resp.json();
}